module.exports = __webpack_public_path__ + "img/矢印アイコン左4.d65c513f.svg";